<div class="modal-header">
    <h5 class="modal-title">EEAR {{getEEARTypeName()}} Report Information</h5>
    <button type="button" class="btn btn-info cancel" (click)="activeModal.dismiss('cancel')"><i
            class="fas fa-times"></i></button>
</div>

<div class="modal-body">
    <div *ngIf="eearType==eearTypes.INDIVIDUALS" class="row m-2">
        <div class="col-md-12">
            <div>
                This report provides data for the purposes of completing the Educator Effectiveness Annual Report
                (EEAR). Please note that this information is as accurate as the information reported on completed 13
                rating forms. This data is reported with the following parameters:
                <ol>
                    <li>
                        If multiple 13 rating forms were completed for an individual in the selected school year, the
                        ratings of each are reported. The Rating Date indicates which 13 rating form is the most recent.
                    </li>
                    <li>
                        If a user is not listed, please ensure that a 13 rating form was completed by reviewing
                        information on the Supervision Management page and/or the individual's User Summary page.
                    </li>
                </ol>
                <div style="font-weight: bold;">
                    ESSA Effectiveness Ratings are included based upon the 2017-18 requirement from PDE. Total earned
                    points ranging from 0.00-1.99 are considered Ineffective and 2.00-3.00 are considered Effective.
                </div>
                <br />
                <div style="font-weight: bold;">
                    * ESSA ratings will be for both Professional and Temporary Classroom Teachers. For Classroom Teachers
                    that are Temporary Professional Employees, the most recent Semi-Annual rating will be used to calculate
                    the ESSA score (i.e., Domain II - 37.5%, Domain III - 37.5% and Domain IV - 25%).
                </div>
                <br />
                <div style="font-weight: bold;">
                    For purposes of completing the annual Educator Effectiveness Annual Report, aggregate ESSA
                    Effectiveness Rating scores are provided by building on the Buildings tab.
                </div>
            </div>
            <br />
            <div style="text-align: center;">
                <a href="https://edulinksolutions.freshdesk.com/support/solutions/articles/13000108228-educator-effectiveness-annual-report-eear"
                    target="_blank">Learn More</a>
            </div>
        </div>
    </div>
    <div *ngIf="eearType==eearTypes.BUILDINGS" class="row m-2">
        <div class="col-md-12">
            <div>
                This report provides data for the purposes of completing the aggregated data portions of the Educator
                Effectiveness Annual Report (EEAR). Please note that this information is as accurate as the information
                reported on completed 13 rating forms. This data is reported with the following parameters:
                <ol>
                    <li>
                        If multiple 13 rating forms were completed for an individual in the selected school year, the
                        ratings from the most recent form ('Rating Date' field on the 13 rating form) is reported.
                    </li>
                    <li>
                        The building assignment reported for each individual is based upon the building selected in the 
                        'School' drop down field on the 13 rating form. However, for 13-2 and 13-3 rating forms, if the 
                        individual works in multiple buildings, then the percent assigned to different buildings on the 
                        13-2 or 13-3 form is reflected on the report.
                    </li>
                    <li>
                        The exception to rule #2 is if ‘District Level’ is selected as the ‘School’. For example, if
                        ‘District Level’ is selected as the ‘School’ on a completed 13-2 or 13-3 rating form for an
                        administrator, then their final score will be reported for the District Level building.
                    </li>
                </ol>
                <div style="font-weight: bold;">
                    ESSA Effectiveness Ratings are included based upon the 2017-18 requirement from PDE. Total earned
                    points ranging from 0.00-1.99 are considered Ineffective and 2.00-3.00 are considered Effective. Individual
                    scores are provided on the Individuals tab.
                </div>
                <br />
                <div style="font-weight: bold;">
                    For Temporary Professional Employees, two Semi-Annual rating forms (13-1 and/or 13-3) should be
                    completed each school year. For ESSA purposes, the most recent Semi-Annual rating will be used to
                    calculate the ESSA score (i.e., Domain II - 37.5%, Domain III - 37.5% and Domain IV - 25%).
                </div>
            </div>
            <br />
            <div style="text-align: center;">
                <a href="https://edulinksolutions.freshdesk.com/support/solutions/articles/13000108228-educator-effectiveness-annual-report-eear"
                    target="_blank">Learn More</a>
            </div>
        </div>
    </div>
</div>